
import React, { } from "react";
import { Row, Select, Button, Col, Progress, message, Form, Breadcrumb, Divider, Radio, Upload, Input, Alert } from "antd";
import $ from 'jquery'
import "./upload.css"

import Footer from '../../Footer/index'
import TextArea from "antd/lib/input/TextArea";
import circleimg from '../resources/circle.png'
import uploadimg from '../resources/upload_main.png'
import '../../../config/api'

import PDF from 'react-pdf-js';
import {
    LinkOutlined,
    PauseCircleOutlined, StepForwardOutlined
} from '@ant-design/icons';
import { Link, Route } from "react-router-dom";
import Header2 from "../../Header/Header2";
import Header4 from "../../Header/Header4";
import Navigator from '../../Navigator'
const pdf02standard = require("../../../statics/file/0-2级标准影像数据规范.pdf");
const { Option } = Select;
var WebUploader = window.WebUploader;
const { Dragger } = Upload;
var uploader
export default class FileUpload extends React.Component {
    state = {
        // fileList: [],
        // filetype: 1,
        // uploading: false,
    }
    jsReadFiles = (files) => {

        var file = document.getElementById("file").files[0];

        // var file = files[0];

        console.log(file.type)

        var reader = new FileReader();//new一个FileReader实例

        // if (/text+/.test(file.type)) {//判断文件类型，是不是text类型

        //     reader.onload = function () {

        //         console.log(this.result)

        //     }

        //     reader.readAsText(file);

        // } else if (/image+/.test(file.type)) {//判断文件是不是imgage类型

        //     reader.onload = function () {

        //         console.log(this.result)

        //     }

        //     reader.readAsDataURL(file);

        // }

    }
    componentDidMount() {
        // this.inituploader()
        WebUploader.Uploader.unRegister('custom');
        var _this=this
        WebUploader.Uploader.register({
            name: 'custom',
            'before-send-file': 'beforeSendFile',//整个文件上传前  可以进行压缩、裁剪、分片操作
            'before-send': 'beforeSend', //每个分片上传前
            "after-send-file": "afterSendFile"  //所有分片上传完毕
        }, {
            beforeSendFile: function (file) {
                var deferred = WebUploader.Deferred();// Deferred详解 ：https://www.cnblogs.com/chris-oil/p/8922770.html

                console.log("准备上传文件" + file.name)
                // console.log("当前上传类型" + _this.props.type)
                // Deferred对象在钩子回掉函数中经常要用到，用来处理需要等待的异步操作。

                var { fileList } = _this.state;
                // console.log(" deferred. not  reject():")
                // 根据文件内容来查询MD5
                uploader.md5File(file, 0, 3 * 1024 * 1024).progress(function (percentage) {   // 及时显示进度
                    // console.log(percentage)
                    //getProgressBar(file, percentage, "MD5", "MD5");
                }).then(function (val) { // 完成
                    file.md5 = val;
                    file.uid = WebUploader.Base.guid();    //生成唯一id      
                    // if (fileList[_this.findfileindexbyid(file.id)] == null) {
                    //     // console.log(" deferred.reject():")
                    //     deferred.reject()
                    //     return deferred.promise();
                    // }
                    if (file.removed || file.finished) {
                        console.log(file.name + "  文件已经被移除 或 成功上传")
                        deferred.reject()
                    }
                    else {
                        // console.log("验证文件是否已经上传过了" + file.name)
                        // $.ajax({
                        //     type: "POST",
                        //     url: global.api_root.uploadURL + "/file/checkFileIsExist",  //验证文件是否已经上传过了，秒传
                        //     async: false,
                        //     data: {
                        //         fileMd5: val
                        //     },
                        //     success: function (data) {
                        //         var isexist = data.exist;
                        //         var { fileList } = _this.state;

                        //         if (isexist) {//文件已经存在了
                        //             // fileList[_this.findfileindexbyid(file.id)].state ='秒传成功'
                        //             // fileList[_this.findfileindexbyid(file.id)].progress = 100
                        //             // _this.setState({ fileList: fileList })
                        //             file.exist = true
                        //             deferred.reject()
                        //         } else {
                        //             // fileList[_this.findfileindexbyid(file.id)].state ='正在上传...'
                        //             // _this.setState({ fileList: fileList }) 
                        //             deferred.resolve();
                        //         }
                        //     }, error: function () {
                        //         deferred.reject()
                        //         alert('文件' + file.name + '链接服务器出错')
                        //         // var { fileList } = _this.state;
                        //         // fileList[_this.findfileindexbyid(file.id)].state ='上传出错'
                        //         // fileList[_this.findfileindexbyid(file.id)].progress = 0
                        //         // _this.setState({ fileList: fileList })
                        //     }
                        // });
                        //不做验证了 ， 反正到时候数据库分系统不配合的话也没啥用
                        deferred.resolve();
                        //
                    }
                });
                return deferred.promise();
            },
            beforeSend: function (block) {
                console.log("分片上传 beforeSend-block:")
                console.log(block)
                var indexchunk = block.file.indexcode;//获取已经上传过的下标
                var deferred = WebUploader.Deferred();
                $.ajax({
                    type: 'GET',//"POST",
                    url:global.support.ossUpload + '/oss/checkExist?md5=' +  block.file.md5,// global.api_root.uploadURL + "/file/checkChunkIsExist",  //验证文件是否已经上传过了，秒传
                    async: false,
                    data: {
                        fileMd5: block.file.md5,
                        chunk: block.chunk,
                        chunkSize: block.end - block.start
                    },
                    success: function (data) {
                        var isexist = data.exist;
                        if (isexist) {//文件已经存在了
                            deferred.reject()
                        } else
                            deferred.resolve();
                    }, error: function () {
                        deferred.reject()
                        var { fileList } = _this.state;
                        // fileList[_this.findfileindexbyid(block.file.id)].state = '上传中断'
                        _this.setState({ fileList: fileList })
                    }
                });
                // if (indexchunk > 0) {
                //     if (block.chunk > indexchunk) {
                //         //分块不存在，重新发送该分块内容
                //         deferred.resolve();//jQuery规定，deferred对象有三种执行状态----未完成，已完成和已失败。如果执行状态是"已完成"（resolved）,deferred对象立刻调用done()方法指定的回调函数；如果执行状态是"已失败"，调用fail()方法指定的回调函数；如果执行状态是"未完成"，则继续等待，或者调用progress()方法指定的回调函数（jQuery1.7版本添加）。
                //     } else {
                //         //分块存在，跳过
                //         deferred.reject();//已失败
                //     }
                // } else {
                //     //分块不存在，重新发送该分块内容
                //     deferred.resolve();
                // }
                //返回Deferred的Promise对象。
                return deferred.promise();//Query提供了deferred.promise()方法。它的作用是，在原来的deferred对象上返回另一个deferred对象，后者只开放与改变执行状态无关的方法（比如done()方法和fail()方法），屏蔽与改变执行状态有关的方法（比如resolve()方法和reject()方法），从而使得执行状态不能被改变。
            },
            afterSendFile: function (file) {
                if (file.removed || file.finished) {
                    return
                }
                console.log("上传完成 通知合并 afterSendFile:" + file.name)
                //如果所有分块上传成功，则通知后台合并分块
                $.ajax({
                    type: "POST",
                    url: global.api_root.uploadURL + "/file/filewebMerge",  //ajax将所有片段合并成整体
                    data: {
                        fileName: file.name,
                        fileMd5: file.md5,
                        fileSize: file.size,
                        fileType: file.type
                    },
                    success: function (data) {
                        message.success(file.name + "上传成功")
                        // if (data.success) {
                        //     var { fileList } = _this.state;
                        //     fileList[_this.findfileindexbyid(file.id)].state ='文件校验成功，上传完成'
                        //     _this.setState({ fileList: fileList })
                        // }
                    }, error: function () {
                        message.error(file.name + "文件完整性校验失败")
                        // var { fileList } = _this.state;
                        // fileList[_this.findfileindexbyid(file.id)].state ='文件校验失败，请重新上传'
                        // _this.setState({ fileList: fileList })
                    }
                });
            }
        });
    }
    switchtype = (e) => {
        // this.resetwebuploader(e.target.value)
        this.setState({ filetype: e.target.value })
    }
    render() {
        return (<Row gutter={0} style={{ color: 'black', minWidth: 1000 }} className='Upload'>
            <Header4></Header4>
            <Col span={24}>
                {/* <Header /> */}
            </Col>
            <Col span={3} style={{ background: 'rgba(0, 50, 156, 0.1)', minHeight: 1080 }}></Col>
            <Col span={18} >
                {/* <Breadcrumb separator=">>" style={{ marginTop: 20, marginLeft: 20, fontWeight: 'bold' }}>
                    <Breadcrumb.Item>资源服务</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a href="/#/Download">资源检索</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a href="">文件上传</a>
                    </Breadcrumb.Item>
                </Breadcrumb> */}
                <Col span={24} style={{ height: 40 }} />
                <Row style={{ minWidth: 800 }}>
                    <Col span={1} />
                    <Col span={22}>
                        {/* 类型选择 */}
                        <Row style={{ marginBottom: 10, height: 40 }}>
                            <Col span={2} style={{
                                fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                                backgroundRepeat: 'no-repeat'
                            }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>1</Col> </Col>
                            <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>选择上传文件类型:</Col>
                        </Row>
                        <Row>
                            <Col span={2}></Col>
                            <Col span={20}>
                                <Radio.Group buttonStyle="solid" onChange={this.switchtype.bind(this)}>
                                    {/* <Link to='Upload/file'> */}
                                    <Radio.Button value={1} style={{ marginRight: 10, marginBottom: 10 }}>文档            </Radio.Button>
                                    {/* </Link>  <Link to='Upload/baseimg'> */}
                                    <Radio.Button value={2} style={{ marginRight: 10, marginBottom: 10 }}>0-2级数据            </Radio.Button>
                                    {/* </Link> */}
                                    <Radio.Button value={3} style={{ marginRight: 10, marginBottom: 10 }}>3-5级产品            </Radio.Button>
                                    <Radio.Button value={4} style={{ marginRight: 10, marginBottom: 10 }}>基础地理信息数据   </Radio.Button>
                                    {/* <Radio.Button value={5} style={{ marginRight: 10, marginBottom: 10 }}>分布式野外采集数据          </Radio.Button> */}
                                    {/* <Radio.Button value={5} style={{ marginRight: 10, marginBottom: 10 }}>遥感特征数据          </Radio.Button> */}
                                    {/* <Radio.Button value={6} style={{ marginRight: 10, marginBottom: 10 }}>模型数据           </Radio.Button> */}
                                    {/* <Radio.Button value={7} style={{ marginRight: 10, marginBottom: 10 }}>专题定制资源          </Radio.Button> */}
                                    <Radio.Button value={8} style={{ marginRight: 10, marginBottom: 10 }}>其他高级产品           </Radio.Button>
                                </Radio.Group>
                            </Col>
                            <Col span={2}></Col>
                        </Row>
                        <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                        {/* 上传文件 */}

                        {/* <Route path='/Upload/file' component={FiledetailWendang} />
                        <Route path='/Upload/baseimg' component={Filedetail02} /> */}
                        {this.state.filetype === 1 ? <FiledetailWendang display={this.state.filetype === 1 ? 'block' : 'none'}></FiledetailWendang> :
                            this.state.filetype === 2 ? <Filedetail02></Filedetail02> :
                                this.state.filetype === 3 ? <Filedetail35></Filedetail35> :
                                    this.state.filetype === 4 ? <FiledetailBase></FiledetailBase> :
                                        this.state.filetype === 8 ? <Filedetailgaoji></Filedetailgaoji> : null}
                        {/* <FiledetailWendang display={this.state.filetype === 1 ? 'block' : 'none'}></FiledetailWendang>
                        <Filedetail02></Filedetail02>
                        <Filedetail35></Filedetail35>
                        <FiledetailBase></FiledetailBase>
                        <Filedetailgaoji></Filedetailgaoji> */}
                    </Col>
                    <Col span={1} />
                </Row>
                <Col span={24} style={{ height: 20 }} />
            </Col>
            <Col span={3} style={{ background: 'rgba(0, 45,155,0.1)' }}></Col>

            {/* <Col span={24}><Footer />
            </Col> */}
        </Row >
        )
    }
}

class FileUploadList extends React.Component {
    state = {
        fileList: [],
        // uploader: null,
        // author: "",
        // description: "",
    }
    componentDidMount() {
        this.initwebuploader().then(
            this.inituploader
        )
        if (uploader) {
            uploader.destroy()
        }
    }
    pause = (file) => {
        var { fileList } = this.state
        var fileinfo = fileList[this.findfileindexbyid(file.id)]
        if (file.state === '正在上传...') {

            fileinfo.state = '等待上传...'
            uploader.stop(file.id)
        } else {
            fileinfo.state = '正在上传...'
            uploader.upload(file)
        }
        this.setState({ fileList: fileList })
    }
    initwebuploader = () => {
        var dtd = $.Deferred();
        var timer = window.setInterval(() => {
            if (!WebUploader) {
                WebUploader = window.WebUploader;
            }
            else {
                dtd.resolve();
            }
        }, 200)
        return dtd.promise();
    }

    inituploader = () => {
        // var { uploader } = this.state
        var $thelist = $('#thelist');
        // HOOK 这个必须要再uploader实例化前面
        var _this = this
        var type = this.props.type
        var ext, multiple
        switch (type) {
            case 1:
                // ext = {
                //     extensions: "pdf,doc,ppt,pptx,xls,xlsx,docx,rar,zip,7z,tar.gz,war,jar,txt,chm,pdr,azw,prc,mbp,tan,tpz,epub,mobi,rp",
                //     mimeTypes: ".pdf,.doc,.ppt,.pptx,.xls,.xlsx,.docx,.rar,.zip,.7z,.tar.gz,.war,.jar,.txt,.chm,.pdr,.azw,.prc,.mbp,.tan,.tpz,.epub,.mobi,.rp"
                // }
                multiple = false
                break;
            case 2:
                ext = {
                    extensions: "rar",
                    mimeTypes: ".rar"
                }
                multiple = true
                break;
            case 3:
                ext = {
                    extensions: "pdf,doc,ppt,pptx,xls,xlsx,docx,rar,zip,7z,tar.gz,war,jar,txt,chm,pdr,azw,prc,mbp,tan,tpz,epub,mobi,rp",
                    mimeTypes: ".pdf,.doc,.ppt,.pptx,.xls,.xlsx,.docx,.rar,.zip,.7z,.tar.gz,.war,.jar,.txt,.chm,.pdr,.azw,.prc,.mbp,.tan,.tpz,.epub,.mobi,.rp"
                }
                multiple = true
                break;
            case 4:
                ext = {
                    extensions: "pdf,doc,ppt,pptx,xls,xlsx,docx,rar,zip,7z,tar.gz,war,jar,txt,chm,pdr,azw,prc,mbp,tan,tpz,epub,mobi,rp",
                    mimeTypes: ".pdf,.doc,.ppt,.pptx,.xls,.xlsx,.docx,.rar,.zip,.7z,.tar.gz,.war,.jar,.txt,.chm,.pdr,.azw,.prc,.mbp,.tan,.tpz,.epub,.mobi,.rp"
                }
                multiple = true
                break;
            case 5:
                ext = {
                    extensions: "pdf,doc,ppt,pptx,xls,xlsx,docx,rar,zip,7z,tar.gz,war,jar,txt,chm,pdr,azw,prc,mbp,tan,tpz,epub,mobi,rp",
                    mimeTypes: ".pdf,.doc,.ppt,.pptx,.xls,.xlsx,.docx,.rar,.zip,.7z,.tar.gz,.war,.jar,.txt,.chm,.pdr,.azw,.prc,.mbp,.tan,.tpz,.epub,.mobi,.rp"
                }
                multiple = true
                break;
            case 6:
                ext = {
                    extensions: "pdf,doc,ppt,pptx,xls,xlsx,docx,rar,zip,7z,tar.gz,war,jar,txt,chm,pdr,azw,prc,mbp,tan,tpz,epub,mobi,rp",
                    mimeTypes: ".pdf,.doc,.ppt,.pptx,.xls,.xlsx,.docx,.rar,.zip,.7z,.tar.gz,.war,.jar,.txt,.chm,.pdr,.azw,.prc,.mbp,.tan,.tpz,.epub,.mobi,.rp"
                }
                multiple = true
                break;
            case 7:
                ext = {
                    extensions: "rar",
                    mimeTypes: ".rar"
                }
                multiple = true
                break;
            default:
                ext = {
                    extensions: "rar",
                    mimeTypes: ".rar"
                }
                multiple = true
                break;

        }
        //实例化
        uploader = WebUploader.create({
            pick: {  //文件选择器按钮设置
                id: '#filePicker' + this.props.type,
                // label:'点击选择文件',
                // innerHTML:'点击上传文件',
                multiple: multiple  //是否支持多选
            },
            dnd: "#queueList" + this.props.type,
            duplicate: true,//去重， 根据文件名字、文件大小和最后修改时间来生成hash Key
            swf: 'webuploader-0.1.5/Uploader.swf',//？？依赖？
            chunked: true,  //开启分片上传
            chunkSize: 10 * 1024 * 1024, //每片10M 如果要分片，分多大一片？ 默认大小为5M
            //chunkRetry {Boolean} [可选] [默认值：2] 如果某个分片由于网络问题出错，允许自动重传多少次？
            threads: 3,//上传并发数。允许同时最大上传进程数。
            server: global.support.ossUpload + '/oss/uploadChunk',//global.api_root.uploadURL + '/file/filewebUpload',
            auto: true,   //自动上传        
            disableGlobalDnd: true,// 禁掉全局的拖拽功能。这样不会出现图片拖进页面的时候，把图片打开。
            fileNumLimit: 1024,//验证文件总数量, 超出则不允许加入队列
            fileSizeLimit: 50 * 1024 * 1024 * 1024,//50G 验证文件总大小是否超出限制, 超出则不允许加入队列
            fileSingleSizeLimit: 10 * 1024 * 1024 * 1024,//10G 验证单个文件大小是否超出限制, 超出则不允许加入队列
            accept: ext
        });

        // 当有文件被添加进队列的时候
        uploader.on('fileQueued', function (file) {
            console.log(file.name + "  加入队列 on fileQueued:")
            // $thelist.append('<div id="' + file.id +'" class="item">' +
            //'<h4 class="info">' + file.name +'</h4>' +
            //'<p class="state">等待上传...</p>' +
            //'</div>');
            var { fileList } = _this.state
            console.log(file)
            file.state = '等待上传...'
            file.type = _this.props.type
            file.progress = 0
            fileList.push(file)
            _this.setState({ fileList: fileList })
            // console.log(uploader.getFiles('inited'))
            //列表 自己写

            $("#stopBtn").click(function () {
                uploader.stop(true);
            });
            $("#restart").click(function () {
                uploader.upload(file);
            });
        });

        //当某个文件的分块在发送前触发，主要用来询问是否要添加附带参数，大文件在开起分片上传的前提下此事件可能会触发多次。
        uploader.onUploadBeforeSend = function (block, data) {
            console.log(block.file.name + "  分片  上传前  onUploadBeforeSend");
            var file = block.file;
            data.chunkSize = block.end - block.start;
            data.md5 = file.md5 || '';
            data.uid = file.uid;

        };
        // 上传中 进度条
        uploader.on('uploadProgress', function (file, percentage) {
            console.log(file.name + "   上传中 on uploadProgress" + percentage);
            var { fileList } = _this.state;
            if (fileList[_this.findfileindexbyid(file.id)] == null) {
                return
            }

            fileList[_this.findfileindexbyid(file.id)].state = '正在上传...'// + Math.round(percentage * 10000) / 100 + "%"
            fileList[_this.findfileindexbyid(file.id)].progress = Math.round(percentage * 10000) / 100
            _this.setState({ fileList: fileList })
            //  $('#' + file.id).find('p.state').text('正在上传...' + Math.round(percentage * 10000) / 100 + "%");
            // getProgressBar(file, percentage, "FILE", "上传进度");
        });
        // 上传返回结果
        uploader.on('uploadSuccess', function (file) {
            // console.log("上传成功");
            console.log(file.name + "     上传成功，等待服务器文件校验");
            // var text ='上传成功，等待服务器文件校验';
            var { fileList } = _this.state;
            file.finished = true
            var fileinfo = fileList[_this.findfileindexbyid(file.id)]
            fileinfo.state = '完成'
            fileinfo.progress = 100
            _this.setState({
                fileList: fileList
            })
        });
        uploader.on('uploadError', function (file) {
            console.log(file.name + "    上传中断");
            var { fileList } = _this.state;
            var fileinfo = fileList[_this.findfileindexbyid(file.id)]
            if (fileinfo == null) {
                console.log(file.name + "    已被移除");
                return
            }
            if (file.removed || file.finished) {
                console.log(file.name + "    已被移除 或 传输完成");
                return
            }


            if (file.exist) {
                console.log(file.name + "  秒传");
                file.finished = true
                fileinfo.state = '秒传完成'
                fileinfo.progress = 100
            }
            else {
                fileinfo.state = '上传中断'
                console.log(" 失败");
            }
            _this.setState({ fileList: fileList })
        });
        uploader.on('uploadComplete', function (file) {
            console.log(file.name + "   上传任务完成");
        });
        uploader.on('uploadFinished', function (file) {
            console.log("所有上传结束");
            // uploader.reset()
        });
        // this.setState({ uploader: uploader })
    }
    findfileindexbyid = (id) => {
        var { fileList } = this.state
        var index;
        fileList.forEach((v, i) => {
            if (v.id === id) index = i
        })
        return index
    }
    render() {
        return (<div>
            <p>111</p>
            {/* 文件选择*/}
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>3</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>选择上传文件:</Col>
            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20}>
                    <Col id={"queueList" + this.props.type}
                        // style={{display:this.props.display}} 
                        className={'ant-upload ant-upload-drag'} >
                        <div id={'filePicker' + this.props.type} disabled>
                            <Col span={24} style={{ height: 10 }} />
                            <img alt="上传" src={uploadimg} style={{ height: 40, width: 40, marginBottom: 10, marginTop: 10 }}></img>
                            <p className="ant-upload-text">上传文件</p>
                            <p className="ant-upload-hint">点击上传或将文件拖拽至此处                                    </p>
                        </div> </Col>
                    <Col span={24} style={{ height: 12 }} />
                    <Col style={{ fontWeight: 'bold', fontSize: 16 }}>传输列表:</Col>
                    <Divider style={{ marginTop: 20, marginBottom: 10 }} />
                    {/* 传输列表 */}
                    {this.state.fileList.map((file, index) => {
                        // console.log(file)
                        return <Row key={index}>
                            <Col span='1'>
                                <div style={{ fontSize: 18, cursor: 'pointer' }} onClick={this.pause.bind(this, file)}>
                                    {file.state === '正在上传...' ? <PauseCircleOutlined /> :file.state === '等待上传...' ?<StepForwardOutlined />:<div/>}

                                </div>
                            </Col>
                            <Col span='24'>
                                <Row>
                                    <Col span={17} style={{}}>
                                        {file.name}
                                    </Col>
                                    {/* <Col span={4} style={{}}>
                           
                            </Col> */}
                                    {/* <Col span={1} style={{}}></Col> */}
                                    <Col span={4} style={{}}>
                                        {file.size < 1024 ? file.size + 'Byte' : file.size < 1024 * 1024 ? ((file.size / 1024).toFixed(2) + 'KB') : file.size < 1024 * 1024 * 1024 ? ((file.size / 1024 / 1024).toFixed(2) + 'MB') : ((file.size / 1024 / 1024 / 1024).toFixed(2) + 'GB')}
                                    </Col>
                                    <Col span={3} style={{}}>
                                        <div style={{ cursor: 'pointer', color: '#11111151', float: 'right' }} onClick={() => {
                                            // return
                                            var fileList = this.state.fileList
                                            fileList.splice(index, 1)
                                            // uploader.removeFile(file.id, true)
                                            file.removed = true
                                            // debugger
                                            console.log(uploader.getFiles())
                                            // uploader.reset()
                                            // console.log(uploader.getFiles())
                                            this.setState({
                                                fileList: fileList
                                            })
                                        }}>
                                            移出
                                        </div>
                                    </Col>
                                    <Col span={16}>
                                        <Progress
                                            strokeColor={{
                                                '0%': '#6062d3',
                                                //'50%':'yellow',
                                                '100%': '#1a1c8d',
                                            }}
                                            strokeLinecap="square"
                                            percent={file.progress ? file.progress : 0}
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col span='7' style={{ float: 'right' }} >{file.state}</Col>

                                </Row>
                            </Col>
                        </Row>

                    })}
                    <Divider style={{ marginTop: 15, marginBottom: 20 }} />
                    {/* <Button style={{ float: 'right', marginRight: 0 }} id="stopBtn" >暂停</Button>
                    <Button style={{ float: 'right', marginRight: 10 }} id="restart" >开始</Button> */}
                </Col>
                <Col span={2}></Col>
            </Row>
            {/* <Button style={{ float:'right', marginRight: 0 }}>点击上传</Button> */}
<Navigator />
        </div>)
    }
}
class FiledetailWendang extends React.Component {
    state = {
        confirm: false,
        filetype: 0,
        types: [
            '项目过程文档',
            '成果文档',
            '说明文档',
            '验收文档',
            '技术文档',
            '配置文件',
            '数据文件',
            '其他',
        ]
    }
    comfirmUploadData = () => {
        var author = this.refs.author.state.value
        var abstract = this.refs.abstract.state.value
        console.log(author, abstract)
        var confirm = !this.state.confirm
        this.setState({ confirm: confirm })
    }
    selecttype = (type, t) => {
        this.setState({ filetype: type })

    }
    render() {

        return (<div>
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>2</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>填写上传文件信息:</Col>

            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}>
                    <Row>
                        {/* <Col span={3} >文档主题</Col>    <Col span={8}><Input disabled={this.state.confirm}></Input></Col>   */}

                        <Col span={3} className='upload-textblock'>文档类型</Col>
                        <Col span={8}>
                            <Select style={{ width: "100%" }} disabled={this.state.confirm} value={this.state.filetype} onSelect={this.selecttype.bind(this)}>
                                {this.state.types.map((type, index) =>
                                    <Select.Option value={index}>{type}</Select.Option>
                                )}
                            </Select>
                        </Col>
                        <Col span={2}></Col>
                        <Col span={3} className='upload-textblock'>作  者</Col>   <Col span={8}><Input ref='author' disabled={this.state.confirm}></Input></Col>
                        <Col span={24} style={{ height: 8 }} />
                        <Col span={3} className='upload-textblock'>摘  要</Col>
                        <Col span={21}>
                            <TextArea ref='abstract' disabled={this.state.confirm}></TextArea>
                        </Col>
                        <Col span={24} style={{ height: 8 }} />

                        <Col span={2}></Col>
                        {/* </Form> */}
                    </Row>
                </Col>
                <Col span={2}></Col>
                <Col span={22}>
                    {/* <Button style={{ float: 'right', marginRight: 0 }} onClick={this.comfirmUploadData}>
                        {this.state.confirm ? '取消' : '确定'}
                    </Button> */}
                    <div style={{ float: 'right', marginRight: 0, marginTop: 8, color: '#999999' }}>
                        {'文件的附加信息由文件选择时所设置的信息确定'}
                    </div>
                </Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <FileUploadList type={1} display={this.state.confirm ? 'block' : 'none'} />
            {/* {this.state.confirm  } */}


        </div>
        )
    }
}
class Filedetail02 extends React.Component {
    state = {

    }
    handleBtnQuery = () => {
        window.open(pdf02standard, '_blank')
    }
    render() {

        return (<div display={this.props.display}>
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>2</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>0-2级数据上传规范:</Col>

            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}>
                    <Row>
                        <Col span={12}>
                            0-2级数据为标准卫星影像数据，上传文件仅支持打包后的rar文件
                        </Col>
                        <Col span={12} onClick={this.handleBtnQuery}>

                            <div style={{ cursor: 'pointer', float: 'right', color: '#0072e5' }}>
                                <LinkOutlined />
                                &nbsp;&nbsp;
                                0-2级标准影像数据规范
                            </div>

                        </Col>

                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <FileUploadList type={2} />
        </div>
        )
    }
}
class Filedetail35 extends React.Component {
    state = {

    }
    handleBtnQuery = () => {
        window.open(pdf02standard, '_blank')
    }
    render() {

        return (<div display={this.props.display}>
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>2</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>3-5级数据上传规范:</Col>

            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}>
                    <Row>
                        <Col span={12}>
                            3-5级产品数据，上传文件仅支持打包后的rar文件
                        </Col>
                        <Col span={12} onClick={this.handleBtnQuery}>

                            <div style={{ cursor: 'pointer', float: 'right', color: '#0072e5' }}>
                                <LinkOutlined />
                                &nbsp;&nbsp;
                                数据规范
                            </div>

                        </Col>

                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <FileUploadList type={3} />
        </div>
        )
    }
}
class FiledetailBase extends React.Component {
    state = {
        types: [
            'DEM（数字高程）',
            'DOM（正射影像）',
            '地面控制点数据',
            '地形图数据',
            '社会经济地理数据',
        ]
    }
    selecttype = (type, t) => {
        this.setState({ filetype: type })

    }
    handleBtnQuery = () => {
        window.open(pdf02standard, '_blank')
    }
    render() {

        return (<div display={this.props.display}>
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>2</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>数据信息选择:</Col>

            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}>
                    <Row>

                        <Col span={3} className='upload-textblock'>数据类型</Col>
                        <Col span={8}>
                            <Select style={{ width: "100%" }} disabled={this.state.confirm} value={this.state.filetype} onSelect={this.selecttype.bind(this)}>
                                {this.state.types.map((type, index) =>
                                    <Select.Option value={index}>{type}</Select.Option>
                                )}
                            </Select>
                        </Col>
                        <Col span={13}>

                        </Col>
                        <Col span={12}>

                        </Col>
                        <Col span={12} onClick={this.handleBtnQuery}>
                            <div style={{ cursor: 'pointer', float: 'right', color: '#0072e5' }}>
                                <LinkOutlined />
                                &nbsp;&nbsp;
                                基础地理信息数据规范
                            </div>

                        </Col>

                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <FileUploadList type={4} />
        </div>
        )
    }
}
class Filedetailgaoji extends React.Component {
    state = {

    }

    render() {

        return (<div display={this.props.display}>
            <Row style={{ marginBottom: 10, height: 40 }}>
                <Col span={2} style={{
                    fontSize: 20, color: "white", background: "url(" + circleimg + ")", backgroundSize: '35px 35px',
                    backgroundRepeat: 'no-repeat'
                }}> <Col style={{ marginLeft: 11, marginTop: 7 }}>2</Col> </Col>
                <Col span={20} style={{ fontWeight: 'bold', fontSize: 16, marginTop: 5 }}>数据上传:</Col>

            </Row>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}>
                    <Row>
                        <Col span={12}>
                            尚未开放
                        </Col>
                        <Col span={12} >



                        </Col>

                    </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            {/* <FileUploadList type={2} /> */}
        </div>
        )
    }
}
class Filedetailyaogan extends React.Component {
    state = {

    }
    selecttype = () => {

    }
    render() {
        return (<div>
            <Row>
                <Col span={2}></Col>
                <Col span={20} style={{}}><Row>
                    {/* <Col span={3} >文件xx</Col>    <Col span={8}><Input></Input></Col>  <Col span={2}></Col>
            <Col span={3}>云量</Col>   <Col span={8}><Input></Input></Col>
            <Col span={24} style={{ height: 8 }} />
            <Col span={3}>描述</Col>
            <Col span={21}>
                <TextArea></TextArea>
            </Col>
            <Col span={24} style={{ height: 8 }} /> */}
                    <Col span={12} >遥感光谱特征数据类型</Col>
                    <Col span={12}>
                        <Select style={{ width: "100%" }} defaultValue={0} onSelect={this.selecttype.bind(this)}>
                            <Select.Option value={0}>土壤遥感</Select.Option>
                            <Select.Option value={1}>岩矿遥感</Select.Option>
                            <Select.Option value={2}>植被遥感</Select.Option>
                            <Select.Option value={3}>城市目标遥感</Select.Option>
                            <Select.Option value={4}>地表大气遥感</Select.Option>
                            <Select.Option value={5}>水体遥感</Select.Option>
                        </Select>
                    </Col>
                    {/* <Col span={2}></Col> */}
                </Row>
                </Col>
                <Col span={2}></Col>
            </Row>
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <FileUploadList />
        </div>)
    }
}